import React, { FC, memo } from 'react'
import { UIPlacement } from 'Pages/landings/newLandings/common/constants'
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip, IconWrapper } from './styled'

interface Position {
	x: number
	y: number
}
export interface CustomPosition {
	name: string
	fn: (position: Position) => Position
}

type Middleware = Partial<Record<string, any>> & {
	name?: string
	fn?: (position: Position) => Position
}
export interface TooltipProps {
	children?: string | JSX.Element | React.HTMLAttributes<unknown>
	tooltipId: string
	title?: string | JSX.Element
	place?: UIPlacement
	className?: string
	iconWrapper?: () => JSX.Element
	noArrow?: boolean
	middlewares?: Middleware[]
}

export const TooltipComponent: FC<TooltipProps> = memo(
	({
		title,
		children,
		place = UIPlacement.TOP,
		tooltipId = 'global',
		iconWrapper,
		className,
		noArrow = false,
		middlewares,
	}) => {
		const defaultWrapper = iconWrapper ? null : <IconWrapper id={tooltipId}>{children}</IconWrapper>
		return (
			<>
				{iconWrapper ? iconWrapper() : defaultWrapper}
				<Tooltip
					anchorId={tooltipId}
					place={place}
					className={className}
					noArrow={noArrow}
					middlewares={middlewares}
				>
					{title}
				</Tooltip>
			</>
		)
	}
)
